import React from "react";
import cn from "classnames";
import styles from "./Users.module.sass";
import {Link} from "react-router-dom";

const Users = ({className, items}) => {
  return (
    <div className={cn(styles.users, className)}>
      <div className={styles.list}>
        {items && items.map((x, index) => (
          <div className={styles.item} key={index}>
            <div className={styles.avatar}>
              <img src={x.avatar} alt="Avatar"/>
            </div>
            <div className={styles.details}>
              <div className={styles.position}>{x.position}</div>
              <div className={styles.name}>
                <Link to={'/profile/' + x.address}>{x.username}</Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Users;
